export default {
  reviewsInRcPay: "Отзывы в RC PAY",
  hideStatus: "Скрыть со страницы вашей торговой точки на сайте rcpay.ru?",
  showStatus: "Показать на странице вашей торговой точки на сайте rcpay.ru?",
  review: "Отзыв",
  ratings: "Оценки",

  status: {
    all: "Все",
    publish: "Опубликованные",
    hidden: "Скрытые",
  },

  hidden: "Скрыт",
  published: "Опубликован",

  zeroHide: "Скрыто",
  zeroPublished: "Опубликовано",

  aboutChapter: {
    title: "Информация о разделе",
    descriptions: [
      "В подразделе «Отзывы» находятся отзывы всех клиентов, которые посещали ваши заведения и оставили отзыв в RC PAY.",
      "Отзывы без текста с оценками 4 и 5 звезд публикуются автоматически. Все остальные отзывы по умолчанию скрыты и не отображаются в RC PAY, но учитываются при расчете общей оценки заведения. Чтобы они стали  видимыми, их необходимо опубликовать.",
    ],
    howPublishOrHide: {
      title: "Как опубликовать или скрыть отзывы в RC PAY?",
      list: [
        "Выберите один или несколько отзывов.",
        "В появившейся нижней панели действий нажмите «Опубликовать» или «Скрыть».",
      ],
    },
    howFilter: {
      title: "Как можно фильтровать / сортировать отзывы?",
      description:
        "Для удобной работы с отзывами предусмотрены фильтры и сортировка:",
      list: [
        "Фильтр по торговым точкам. По умолчанию в списке показаны отзывы, оставленные по всем вашим заведениям. При установке фильтра «Торговые точки» можно отобразить отзывы, оставленные клиентом о данном заведении.",
        "Фильтр по дате. При установке фильтра по дате отобразятся отзывы за выбранный вами период или дату.",
        "Сортировать отзывы можно по новизне (сначала новые / старые) или по оценке (сначала отрицательные / положительные)",
      ],
    },
  },

  noReviewsYet: "Отзывов пока нет",
  createShopToGetReviews:
    "Создайте торговую точку, чтобы получать отзывы от клиентов RC PAY",
  appearAfterClientSetRating:
    "Они появятся здесь после того, как<br> посетивший ваше заведение клиент,<br> поставит ему оценку в RC PAY",
  noPublishedReviews: "Опубликованных отзывов нет",
  allReviewsHiddenInRc: "Все отзывы скрыты в RC PAY",
  allReviews: "Все отзывы",
  allRatings: "Все оценки",
  noHiddenReviews: "Скрытых отзывов нет",
  allReviewsShownInRc: "Все отзывы опубликованы в RC PAY",

  sort: {
    firstNew: "Сначала новые",
    firstOld: "Сначала старые",
    goodFirst: "Оценка по убыванию",
    badFirst: "Оценка по возрастанию",
  },

  removeSelection: "Снять выделение",
  chooseAllReviews: "Выбрать все отзывы",
  overallAssessment: {
    title: "Общая оценка",
    hint: [
      "При установке фильтров общая оценка и количество отзывов пересчитываются.",
      "Общая оценка учитывает все отзывы, в т.ч. скрытые в RC PAY.",
    ],
  },
  totalAmountReviews: "Всего отзывов",
  amountPublishReviews: "Опубликованных отзывов",
  amountHiddenReviews: "Скрытых отзывов",
  userPhoto: "Фото пользователя",
  showInRcPay: "Показать в RC PAY",
  hideInRcPay: "Скрыть в RC PAY",
  hiddenReviewsNotVisibleToRcPayUsers:
    "Скрытые отзывы не видно пользователям RC PAY, но учтены в общей оценке вашего заведения. Чтобы их отобразить, выберите один или несколько отзывов, затем в появившейся нижней панели действий нажмите «Опубликовать в RC PAY»",
};
